/**
 * Textos centrados que se hacen largos (LNY).
 *
 * Un bloque centrado se lee bien mientras es corto: el ojo encuentra el arranque
 * de cada linea sin buscarlo. Pasadas TRES lineas deja de compensar —cada linea
 * empieza en un sitio distinto y el bloque se convierte en ruido—, asi que a
 * partir de ahi el texto se alinea a la izquierda. La caja sigue centrada en su
 * modulo: lo que cambia es donde empiezan las lineas, no donde vive el bloque.
 *
 * Esto NO se puede resolver en CSS: no hay forma de preguntar cuantas lineas
 * ocupa un texto, y el numero depende del ancho, del idioma y de la fuente que
 * acabe cargando. Se mide.
 *
 * ⚠️ Vive fuera de lny-motion.js a proposito: aquello entero corre bajo
 * `prefers-reduced-motion: no-preference` y esto no es motion, es composicion —
 * con el motion apagado tiene que aplicarse igual.
 */
(() => {
  const LIMITE_LINEAS = 3;

  /* Los candidatos son los textos CORRIDOS, no los titulares: un titular a
     cuatro lineas es una pieza compuesta y centrarlo es una decision de diseno.
     Aqui hablamos de descripciones y bajadas. */
  const SELECTOR = [
    '.section-heading__subtitle',
    '.product-card__description',
    '.rte p',
    '[data-text-fit]',
  ].join(',');

  const lineas = (el) => {
    const cs = getComputedStyle(el);
    let alturaLinea = parseFloat(cs.lineHeight);
    /* `line-height: normal` no da un numero: se estima desde el cuerpo, que es
       lo que hace el propio navegador (~1,2). */
    if (!Number.isFinite(alturaLinea)) alturaLinea = parseFloat(cs.fontSize) * 1.2;
    if (!alturaLinea) return 0;
    const alto = el.getBoundingClientRect().height
      - parseFloat(cs.paddingTop)
      - parseFloat(cs.paddingBottom);
    return Math.round(alto / alturaLinea);
  };

  const revisar = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      /* Se mide SIEMPRE sobre el estado original. Cambiar `text-align` no altera
         donde parte el texto —el ancho es el mismo—, asi que el numero de lineas
         no cambia y esto no puede entrar en bucle. */
      const largo = lineas(el) > LIMITE_LINEAS;
      el.classList.toggle('is-long-text', largo);
    });
  };

  /* Despues de las fuentes: la Explorer y la Figtree cargan con `swap`, y medir
     con la fuente de sistema da un recuento de lineas que no es el definitivo. */
  const arrancar = () => {
    revisar();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(revisar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  let pendiente = null;
  window.addEventListener('resize', () => {
    /* El ancho manda en cuantas lineas salen, asi que al redimensionar hay que
       volver a contar. Agrupado en un frame para no medir en cada pixel. */
    if (pendiente !== null) return;
    pendiente = requestAnimationFrame(() => {
      pendiente = null;
      revisar();
    });
  });
})();
